module.exports = __webpack_public_path__ + "media/Video 94.ef08c653.mp4";